import { render, staticRenderFns } from "./GoToCard.vue?vue&type=template&id=1886a50f&scoped=true&"
import script from "./GoToCard.vue?vue&type=script&lang=ts&"
export * from "./GoToCard.vue?vue&type=script&lang=ts&"
import style0 from "./GoToCard.vue?vue&type=style&index=0&id=1886a50f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1886a50f",
  null
  
)

export default component.exports